import React, { useContext } from 'react';
import { GlobalStateDataContext } from '../../context-api/data-provider/GlobalStateDataProvider';
import LiveTimer from '../../composed/LiveTimer/LiverTimer';
import { orderStatusMapping } from '../../utils/constants';
import AtomicButton from '../../atomic/button/Button';
import RunCircleIcon from '@mui/icons-material/RunCircle';
import AccessTimeIcon from '@mui/icons-material/AccessTime';
import LocalShippingIcon from '@mui/icons-material/LocalShipping';
import CookingTimer from '../../composed/LiveTimer/CookingTimer';
import TextTransformation from '../../utils/textTransformation';
import { OrderDataProviderContext } from '../../context-api/data-provider/OrderDataProvider';
import Snackbar from '@mui/material/Snackbar';
import { Dialog } from '@mui/material';
import './dashboard.scss';
import './action-order-detail.scss';
import UpdateOrderTime from './UpdateOrderTime';
import CancelOrder from './CancelOrder';
import PrintReceipt from '../../composed/printReceipt/PrintReceipt';
import { getFriendlyDateLabel } from '../../utils/dateFormat';
import { DisplayIcon } from '../../utils/DisplayIcons';
import NoOrderFound from './NoOrderFound';
import PickupFreeItemNotice from './PickupFreeItemNotice';
import MealItemNamesSection from './MealItemNamesSection';

const InProgressOrder = () => {
  const {
    isLoggedIn,
    selectedMenuTab,
    setSelectedMenuTab,
    setisLoggedIn,
    newPendingOrder,
    setNewPendingOrder,
    preparingOrder,
    setPreparingOrder,
    scheduledOrder,
    setScheduledOrder,
    openOrderAlert,
    setOpenOrderAlert,
    allOrders,
    setAllOrders,
    openUpdateTimeDialog,
    setOpenUpdateTimeDialog,
    openCancelOrderDialog,
    setOpenCancelOrderDialog,
    orderReadyForPickup,
    setOrderReadyForPickup,
    openSnackBar,
    setOpenSnackBar,
  } = useContext(GlobalStateDataContext);

  const {
    onUpdateOrderStatus,
    updateOrderAPIResponse,
    setUpdateOrderAPIResponse,
    FetchOrders,
    clickedOrder,
    KitchenName,
    clickedPreparingOrder,
    setClickedPreparingOrder,
  } = useContext(OrderDataProviderContext);

  const { loading } = updateOrderAPIResponse;
  const { vertical, horizontal, open } = openSnackBar;

  const [startNo, endNo] = (clickedPreparingOrder?.order_no || '').split('-');
  const isMealOrder = endNo?.includes('MEAL');

  const renderOrderItem = (item, index) => {
    let price = 'Meal item';
    let isMealItem = false;

    if (item?.price) {
      price = item.qty * item.price;
    }

    if (item?.product_category) {
      isMealItem = true;
    }

    const displayPrice = price === 'Meal item' ? 'Meal item' : `$${price}`;

    if (
      item?.promotion === 'buy_one_get_one_free' &&
      price !== 'Meal item' &&
      item.qty > 1
    ) {
      price = (item.qty - Math.floor(item.qty / 2)) * item.price;
    } else if (
      item?.promotion === 'buy_two_get_one_free' &&
      price !== 'Meal item' &&
      item.qty > 2
    ) {
      price = (item.qty - Math.floor(item.qty / 3)) * item.price;
    } else if (
      item?.promotion === 'buy_one_get_half_price' &&
      price !== 'Meal item' &&
      item.qty > 1
    ) {
      price =
        (item.qty - Math.floor(item.qty / 2) + Math.floor(item.qty / 2) / 2) * item.price;
    }

    return (
      <div className='action-order-detail__item' key={`${item?.item}_${index}`}>
        <div className='action-order-detail__item-row'>
          <span className='action-order-detail__qty'>{item.qty}</span>
          <div className='action-order-detail__item-body'>
            <div className='action-order-detail__item-name'>{item.item}</div>
            {item?.promotion && (
              <div className='action-order-detail__item-promo'>
                Applied -{' '}
                <span className='action-order-detail__item-promo-label'>
                  {TextTransformation(item?.promotion)}
                </span>
              </div>
            )}
            {isMealItem && <div className='action-order-detail__item-tag'>Meal item</div>}
          </div>
          <div className='action-order-detail__item-price'>{displayPrice}</div>
        </div>
        {item?.extra_toppings?.length > 0 && (
          <div className='action-order-detail__topping-list'>
            {item.extra_toppings.map((t) => (
              <div className='action-order-detail__topping-row' key={t.topping_name}>
                <span className='action-order-detail__topping-name'>
                  {`${t.topping_name} (${t.topping_qty})`}
                </span>
                <span className='action-order-detail__topping-price'>
                  ${(t.topping_qty * t.price).toFixed(2)}
                </span>
              </div>
            ))}
          </div>
        )}
      </div>
    );
  };

  const renderMealOrderItem = (item, index) => {
    const price = 'Meal item';

    return (
      <div className='action-order-detail__item' key={`${item?.item}_${index}`}>
        <div className='action-order-detail__item-row'>
          <span className='action-order-detail__qty'>{item.qty}</span>
          <div className='action-order-detail__item-body'>
            <div className='action-order-detail__item-name'>{item.item}</div>
            {item?.promotion && (
              <div className='action-order-detail__item-promo'>
                Applied -{' '}
                <span className='action-order-detail__item-promo-label'>
                  {TextTransformation(item?.promotion)}
                </span>
              </div>
            )}
            {item?.product_category && (
              <div className='action-order-detail__item-tag'>Meal item</div>
            )}
          </div>
          <div className='action-order-detail__item-price'>{price}</div>
        </div>
        {item?.extra_toppings?.length > 0 && (
          <div className='action-order-detail__topping-list'>
            {item.extra_toppings.map((t) => (
              <div className='action-order-detail__topping-row' key={t.topping_name}>
                <span className='action-order-detail__topping-name'>
                  {`${t.topping_name} (${t.topping_qty})`}
                </span>
                <span className='action-order-detail__topping-price'>
                  ${(t.topping_qty * t.price).toFixed(2)}
                </span>
              </div>
            ))}
          </div>
        )}
      </div>
    );
  };

  const handleClose = (event, reason) => {
    setOpenSnackBar({
      ...openSnackBar,
      warning: false,
      open: false,
      snakBarMessage: '',
    });

    if (reason === 'clickaway') {
      return;
    }
  };

  const promoTypeLabel = (discount_type, discountedAmount) => {
    // You have to create paths on app.js before coming here to add tan name
    switch (discount_type) {
      case 'percentage':
        return `${discountedAmount}% off`;
      case 'plates':
        return `${discountedAmount} Free meal`;
      case 'amount_off':
        return `- $${discountedAmount} off`;
      case 'product':
        return `- $${discountedAmount} off`;
      case 'free_delivery':
        return `- $${discountedAmount} Delivery off`;
      case 'percentage_delivery':
        return `${discountedAmount}% Delivery off`;
      case 'free':
        return `Free order`;
    }
  };

  const HandleAcceptSubmit = async () => {
    const payload = {
      order_no: clickedPreparingOrder?.order_no,
      user_type: 'kitchen',
      operation: 'order ready for pickup',
    };

    setOpenSnackBar({
      ...openSnackBar,
      warning: false,
    });

    const checkResp = await onUpdateOrderStatus(payload);

    if (checkResp?.success && checkResp?.message === 'Order is ready for pickup now!') {
      const indexToRemove = preparingOrder.findIndex(
        (order) => order.order_no === clickedPreparingOrder?.order_no
      );

      if (indexToRemove !== -1) {
        setPreparingOrder((prevOrders) => {
          const filteredOrders = prevOrders.filter(
            (order) => order.order_no !== clickedPreparingOrder?.order_no
          );
          return [...filteredOrders]; // Add only if not a duplicate
        });

        setOrderReadyForPickup((prevOrders) => {
          const filteredOrders = prevOrders.filter(
            (order) => order.order_no !== clickedPreparingOrder?.order_no
          );
          return [
            ...filteredOrders,
            { ...clickedPreparingOrder, internal_order_status: 'order ready for pickup' },
          ]; // Add only if not a duplicate
        });
      }

      localStorage.removeItem(`startTime_${clickedPreparingOrder?.order_no}`);
      setClickedPreparingOrder({});
      setOpenSnackBar({
        ...openSnackBar,
        open: true,
        warning: false,
        snakBarMessage: 'Order successfully marked as ready',
      });
    }

    if (
      (checkResp?.success === false &&
        checkResp?.message === 'Operation is not allowed at this stage') ||
      checkResp?.message?.includes('Order with the order number')
    ) {
      setOpenSnackBar({
        ...openSnackBar,
        open: true,
        snakBarMessage: 'Action not permitted at this stage',
        warning: true,
      });
    }
  };

  if (preparingOrder?.length <= 0) {
    return <NoOrderFound />;
  }

  return (
    <div style={{ display: 'flex', height: '96vh' }}>
      <div
        style={{
          width: '32%',
          borderRight: '1px solid #ccd0d5',
          backgroundColor: 'rgb(254, 247, 200)',
        }}
      >
        {preparingOrder.map((item) => {
          const [startNo, endNo] = item.order_no.split('-');
          const totalItems = item?.item_names?.length;
          const mealTotalItems = item?.item_name?.length;

          return (
            <div
              style={{
                display: 'flex',
                flexDirection: 'row',
                // alignItems: 'center',
                alignItems: 'center',
                justifyContent: 'space-between',
                height: 'auto',
                borderRadius: '3px',
                margin: '4px',
                padding: '10px 10px 20px 10px',
                backgroundColor: '#81E7AF',
                color: '#1E3E62',
                cursor: 'pointer',
              }}
              onClick={() => {
                setClickedPreparingOrder(item);
              }}
            >
              <div style={{ display: 'flex', flexDirection: 'column' }}>
                <div
                  style={{
                    fontSize: '16px',
                    fontFamily: 'Inter Bold',
                    textTransform: 'capitalize',
                    letterSpacing: '0.5px',
                    marginBottom: '10px',
                  }}
                >
                  {' '}
                  {item.cust_firstName}
                </div>

                <div style={{ fontFamily: 'Inter Regular', fontSize: '14px' }}> {`# ${endNo}`}</div>
                <div style={{ fontFamily: 'Inter Regular', fontSize: '14px' }}>
                  {' '}
                  {totalItems || mealTotalItems}{' '}
                  {totalItems === 1 || mealTotalItems === 1 ? 'item' : 'items'}{' '}
                </div>
                <div
                  style={{
                    display: 'flex',
                    justifyContent: 'center',
                    border: '2px solid #1E3E62',
                    backgroundColor: '#1E3E62',
                    fontSize: '14px',
                    borderRadius: '3px',
                    padding: '2px 5px 2px 5px',
                    color: 'white',
                    marginTop: '10px',
                    textTransform: 'uppercase',
                  }}
                >
                  {orderStatusMapping[item.internal_order_status]}
                </div>
              </div>

              <div
                style={{
                  display: 'flex',
                  flexDirection: 'column',
                  alignItems: 'center',
                  justifyContent: 'space-between',
                }}
              >
                <div> Ready time</div>
                <div
                  style={{
                    display: 'flex',
                    alignItems: 'center',
                    justifyContent: 'center',
                    border: '2px solid rgb(24, 20, 54)',
                    backgroundColor: '#fff4e7',
                    borderRadius: '5px',
                    marginTop: '5px',
                    width: '80px',
                    height: '40px',
                  }}
                >
                  <CookingTimer orderId={item.order_no} minutes={20} />
                </div>
              </div>
            </div>
          );
        })}
      </div>

      {Object.keys(clickedPreparingOrder).length > 0 && (
        <div className='action-order-detail-wrapper'>
          <div className='action-order-detail'>
            <div className='action-order-detail__inner'>
              <header className='action-order-detail__header'>
                <div className='action-order-detail__header-top'>
                  <div className='action-order-detail__customer-block'>
                    <div className='action-order-detail__customer-name-row'>
                      <h2 className='action-order-detail__customer-name'>
                        {clickedPreparingOrder?.cust_firstName}
                      </h2>
                      {DisplayIcon({
                        item: clickedPreparingOrder,
                        KitchenName: KitchenName,
                        color: 'none',
                      })}
                    </div>
                    <p className='action-order-detail__order-no'>{endNo}</p>
                  </div>

                  <div className='action-order-detail__delivery-block'>
                    {clickedPreparingOrder?.delivery_type === 'home delivery' && (
                      <span className='action-order-detail__delivery-type'>
                        <LocalShippingIcon sx={{ color: '#181436', fontSize: 20 }} />
                        Home Delivery
                      </span>
                    )}
                    {clickedPreparingOrder?.delivery_type === 'pickup' && (
                      <span className='action-order-detail__delivery-type'>
                        <RunCircleIcon sx={{ color: '#181436', fontSize: 20 }} />
                        Pickup
                      </span>
                    )}
                    {clickedPreparingOrder?.delivered_by === 'kitchen'}{' '}
                    <span className='action-order-detail__badge action-order-detail__badge--restaurant'>
                      Restaurant Delivery
                    </span>
                    <div className='action-order-detail__print-label'>
                      <PrintReceipt data={clickedPreparingOrder} />
                      <span>Print Label</span>
                    </div>
                  </div>
                </div>

                <div className='action-order-detail__meta-grid'>
                  <div className='action-order-detail__meta-card'>
                    <span className='action-order-detail__meta-label'>Delivery slot</span>
                    <span className='action-order-detail__meta-value'>
                      {clickedPreparingOrder?.delivery_time_slot}
                    </span>
                  </div>
                  <div className='action-order-detail__meta-card'>
                    <span className='action-order-detail__meta-label'>Date</span>
                    <span className='action-order-detail__meta-value action-order-detail__meta-value--date'>
                      {getFriendlyDateLabel(clickedPreparingOrder?.delivery_date)}
                    </span>
                  </div>
                </div>
              </header>

              {isMealOrder === false && Object.keys(clickedPreparingOrder).length > 0 && (
                <section className='action-order-detail__section'>
                  <h3 className='action-order-detail__section-title'>
                    Item{clickedPreparingOrder?.item_names?.length > 1 ? 's' : ''}
                  </h3>
                  <div className='action-order-detail__items-list'>
                    {clickedPreparingOrder?.item_names?.map(renderOrderItem)}
                  </div>
                </section>
              )}

              {isMealOrder === true && Object.keys(clickedPreparingOrder).length > 0 && (
                <section className='action-order-detail__section'>
                  <h3 className='action-order-detail__section-title'>
                    Item{clickedPreparingOrder?.item_names?.length > 1 ? 's' : ''}
                  </h3>
                  <div className='action-order-detail__items-list'>
                    {clickedPreparingOrder?.item_name?.map(renderMealOrderItem)}
                  </div>
                </section>
              )}

              <MealItemNamesSection order={clickedPreparingOrder} />

              <PickupFreeItemNotice order={clickedPreparingOrder} />

              <div className='action-order-detail__summary'>
                <div className='action-order-detail__summary-row'>
                  <span>Sub total</span>
                  <span className='action-order-detail__summary-value'>
                    ${(clickedPreparingOrder?.sub_total || 0.0)?.toFixed(2)}
                  </span>
                </div>
                <div className='action-order-detail__summary-row'>
                  <span>Delivery Fee</span>
                  <span className='action-order-detail__summary-value'>
                    $
                    {clickedPreparingOrder?.delivery_price?.toFixed(2) ||
                      clickedPreparingOrder?.deliverySubscription_fee?.toFixed(2)}
                  </span>
                </div>

                {clickedPreparingOrder?.discount_coupon_no && (
                  <>
                    <div className='action-order-detail__summary-row action-order-detail__summary-row--discount'>
                      <span>Discount</span>
                      <span className='action-order-detail__summary-value'>
                        {promoTypeLabel(
                          clickedPreparingOrder?.discount_type,
                          clickedPreparingOrder?.discountedAmount
                        )}
                      </span>
                    </div>
                    <div className='action-order-detail__summary-row'>
                      <span>Discount code</span>
                      <span
                        className='action-order-detail__summary-value'
                        style={{ textTransform: 'uppercase' }}
                      >
                        {clickedPreparingOrder?.discount_coupon_no}
                      </span>
                    </div>
                  </>
                )}

                <div className='action-order-detail__summary-row'>
                  <span>Tax & other fee</span>
                  <span className='action-order-detail__summary-value'>
                    $
                    {(
                      clickedPreparingOrder?.tax_plus_serviceFees || clickedPreparingOrder?.tax
                    )?.toFixed(2)}
                  </span>
                </div>
                <div className='action-order-detail__summary-row'>
                  <span>Tip</span>
                  <span className='action-order-detail__summary-value'>
                    ${clickedPreparingOrder?.tip?.toFixed(2)}
                  </span>
                </div>

                {clickedPreparingOrder?.promoOrderAmountAdded_In_Total_charged !== 0 && (
                  <div className='action-order-detail__summary-row action-order-detail__summary-row--promo'>
                    <div className='action-order-detail__summary-label-group'>
                      <span>Complimentary Item</span>
                      <span className='action-order-detail__summary-sub'>
                        Packaging & Delivery Fee
                      </span>
                      <span className='action-order-detail__summary-sub action-order-detail__summary-sub--green'>
                        Arriving Tomorrow
                      </span>
                    </div>
                    <span className='action-order-detail__summary-value'>
                      ${clickedPreparingOrder?.promoOrderAmountAdded_In_Total_charged?.toFixed(2)}
                    </span>
                  </div>
                )}

                <div className='action-order-detail__summary-total'>
                  <span>Total</span>
                  <span>${clickedPreparingOrder?.total_charged?.toFixed(2)}</span>
                </div>
              </div>

              <div className='action-order-detail__actions'>
                <div className='action-order-detail__actions-primary'>
                  <AtomicButton
                    label='Order is ready for pickup'
                    handleSubmit={HandleAcceptSubmit}
                    style={{
                      backgroundColor: 'rgb(24, 20, 54)',
                      color: '#fff',
                    }}
                    loading={loading}
                    disabled={loading}
                  />
                </div>
              </div>
            </div>
          </div>
        </div>
      )}

      <Snackbar
        open={open}
        anchorOrigin={{ vertical, horizontal }}
        className={openSnackBar?.warning ? 'warning-order-snackbar' : 'order-snackbar'}
        autoHideDuration={5000}
        onClose={handleClose}
        message={openSnackBar?.snakBarMessage}
      />
    </div>
  );
};

export default InProgressOrder;
